import { toast } from "react-toastify";

const toastConfig = {
  position: "top-right",
  closeOnClick: true,
};

const swal = async (type, text) => {
  switch (type) {
    case "success":
      toast.success(text, { ...toastConfig, autoClose: 3000 });
      break;
    case "info":
      toast.info(text, { ...toastConfig, autoClose: 5000 });
      break;
    default:
      toast.error(text, { ...toastConfig, autoClose: 7000 });
      break;
  }
};

export default swal;
